import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import XCircle from '../Icons/solid/XCircle'

export default function Example({ show, hide, title, children, className }) {

  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" static className="fixed z-50 inset-0 overflow-y-auto" open={show} onClose={hide ? hide : (() => null)}>
        <div className="flex items-end justify-centermin-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className={`inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-visible shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6 ${className}`}>
              <div>
                <div className='flex   justify-between'>
                  <Dialog.Title as="div" className="text-lg font-medium text-secondary">
                    { title }
                  </Dialog.Title>
                  {hide && 
                  <div className='cursor-pointer' onClick={hide}>
                    <XCircle fill={'rgba(209, 213, 219, 1)'} aria-hidden="true" />
                  </div>
                  }
                </div>
                {children}
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}